import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { CheckCircle, Mail } from 'lucide-react';
import { toast } from 'sonner';

const LandingFooter = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith('ar');
  const [email, setEmail] = useState('');

  const handleNewsletter = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    toast.success(t('landing.newsletterSuccess'));
    setEmail('');
  };

  return (
    <footer className="border-t border-border/50">
      {/* Newsletter */}
      <div className="bg-primary/5 py-12 px-4">
        <div className="max-w-xl mx-auto text-center space-y-4">
          <Mail className="h-8 w-8 text-primary mx-auto" />
          <h3 className="text-xl font-bold">{t('landing.newsletterTitle')}</h3>
          <p className="text-sm text-muted-foreground">{t('landing.newsletterDesc')}</p>
          <form onSubmit={handleNewsletter} className={`flex gap-2 max-w-md mx-auto ${isRTL ? 'flex-row-reverse' : ''}`}>
            <Input
              type="email"
              inputDir="ltr"
              placeholder={t('landing.newsletterPlaceholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-xl"
              required
            />
            <Button type="submit" className="rounded-xl shrink-0 px-6">
              {t('landing.newsletterButton')}
            </Button>
          </form>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="py-8 px-4">
        <div className={`max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground ${isRTL ? 'sm:flex-row-reverse' : ''}`}>
          <div className={`flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
            <div className="h-6 w-6 rounded-md bg-primary flex items-center justify-center">
              <CheckCircle className="h-3.5 w-3.5 text-primary-foreground" />
            </div>
            <span className="font-semibold text-foreground">{t('app.name')}</span>
          </div>
          <p>
            {t('app.madeWith')} • {t('app.copyright')} •{' '}
            <a href="https://rutini.app" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors underline underline-offset-2">
              rutini.app
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
